import React from 'react'
import {Route} from 'react-router-dom'
import BankAccounts from './BankAccounts'
import Contacts from './Contacts'
const Layout = React.lazy(() => import('./Layout'))
const Main = React.lazy(() => import('./Main'))
const Security = React.lazy(() => import('./Security'))
const Kyc = React.lazy(() => import('./Kyc'))

export default (
  <Route path="/settings" element={<React.Suspense><Layout /></React.Suspense>}>
    <Route index element={<React.Suspense><Main /></React.Suspense>} />
    <Route path="security" element={<React.Suspense><Security /></React.Suspense>} />
    <Route path="kyc" element={<React.Suspense><Kyc /></React.Suspense>} />
    {BankAccounts}
    {Contacts}
  </Route>
)
